<template>
  <HeaderLayout
    :navigation="navigation"
    :navigationMB="navigationMB"
    :showRightNavigation="showRightNavigation"
    :show-top-bar="showTopBar"
    :showPhoneMB="showPhoneMB"
    new-header
    v-if="hideHeader"
  >
    <template #right-end>
      <!--      <router-link target='_blank' class='ml-30' :to="{ name: 'signup-agent' }"><span class='gray-dark'>Travel Agent Login</span></router-link>-->
      <a class="ml-30 mb-ml-20" target="_blank" :href="goToAgentLogin"><span>Travel Agent Login</span></a>
      <!-- v2 dark mode — guest-accessible theme switch on the top bar (the Account Settings toggle is login-gated). Client-only: colour-mode resolves on the client, so SSR-rendering isDark would hydration-mismatch. Wired to useTheme (client-side preference in `dj-color-mode`), same ToggleButton + semantics as Account Settings. -->
      <client-only>
        <!-- Temporarily hidden at ALL widths pending dark-mode launch (was dt-dn = hidden ≤1140px only) — to re-enable, swap `dn-important` back to `dt-dn` or drop it. Plain `dn` loses to the later-compiled `.flex` rule (equal specificity), hence the -important variant. -->
        <span class="theme-toggle dn-important flex items-center ml-30 mb-ml-20">
          <ToggleButton
            size="small"
            :checked="isDark"
            ariaLabel="Dark mode"
            @update:checked="setDarkMode"
          />
          <span class="pl-8 mb-dn">Dark</span>
        </span>
      </client-only>
    </template>
  </HeaderLayout>
</template>

<script>
import HeaderLayout from './HeaderLayout'
import ToggleButton from '~/components/ui/toggle-button/ToggleButton.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useTheme } from '~/composables/common/useTheme'
import { PHONE } from '~/constant/common'

export default {
  name: 'HeaderTraveller',
  components: { HeaderLayout, ToggleButton },
  setup() {
    const route = useRoute()
    const {isDesktopOrTablet} = useDevice()

    // v2 dark mode — client-side theme preference (persisted to `dj-color-mode`), same wiring as Account Settings' toggle
    const { isDark, colorMode } = useTheme()
    const setDarkMode = (value) => {
      colorMode.preference = value ? 'dark' : 'light'
    }

    const navigation = [
      // {
      //   title: 'Blog',
      //   url: `${process.env.VUE_APP_PUBLIC_DOMAIN_PUBLIC}/blog/`,
      // },
      {
        title: 'How It Works',
        url: '/how-it-works',
      },
    ]

    const navigationMB = [
      // {
      //   title: 'Free Cancellation Trips',
      //   name: 'free-cancelation',
      //   url: '/free-cancellation-trips',
      //   externalURL: '',
      // },
      {
        title: 'About Us',
        name: 'about',
        url: '/about-us',
        externalURL: '',
      },
      {
        title: 'Contact Us',
        name: 'contact',
        url: '/contact-us',
        externalURL: '',
      },
      {
        title: 'Blog',
        name: 'blog',
        url: '',
        externalURL: '/blog/',
      },
      {
        title: 'Careers',
        name: 'careers',
        url: '',
        externalURL: 'https://www.linkedin.com/jobs/search/?f_C=18090474&geoId=92000000&position=1&pageNum=0',
      },
    ]

    const goToAgentLogin = computed(() => {
      return useAppConfig().publicDomainAgent
    })
    const showTopBar = computed(() => {
      return !(
        route.name === 'enquiry-submit-global' ||
        route.name === 'enquiry-submit-destination' ||
        route.name === 'enquiry-submit-ld' ||
        route.name === 'enquiry-submit-trip' ||
        route.name === 'school-tour-details'
      )
    })
    const showPhoneMB = computed(() => {
      return (
        route.name === 'enquiry-submit-global' ||
        route.name === 'enquiry-submit-destination' ||
        route.name === 'enquiry-submit-ld' ||
        route.name === 'enquiry-submit-trip'
      )
    })
    const showRightNavigation = computed(() => {
      return !(
        route.name === 'gallery-enquiry-steps' ||
        route.name === 'trip-gallery-enquiry-steps' ||
        route.name === 'enquiry-steps' ||
        route.name === 'enquiry-local-designer' ||
        route.name === 'enquiry-submit-global' ||
        route.name === 'enquiry-submit-destination' ||
        route.name === 'enquiry-submit-trip' ||
        route.name === 'enquiry-submit-ld' ||
        route.name === 'feedback' ||
        route.name === 'custom-group-tours' ||
        route.name === 'school-tour-details'
      )
    })

    const hideHeader = computed(() => {
      const pages = ['enquiry-submit-global', 'enquiry-submit-destination', 'enquiry-submit-ld', 'enquiry-submit-trip', 'withintrepid']
      if (pages.indexOf(route.name) !== -1 && isDesktopOrTablet) return false
      return true
    })

    return { navigation, navigationMB, goToAgentLogin, showRightNavigation, showTopBar, showPhoneMB, PHONE, hideHeader, isDark, setDarkMode }
  },
}
</script>

<style scoped></style>
